import { forwardRef, type TextareaHTMLAttributes } from 'react';

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
  error?: string;
};

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(
  ({ label, error, className = '', ...props }, ref) => (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label className="block text-[11px] font-bold text-muted uppercase tracking-[0.12em]">
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        rows={4}
        {...props}
        className={`w-full bg-bg px-3 py-2.5 text-sm text-text placeholder-muted outline-none transition-colors rounded-xl resize-none ${error ? 'border border-danger' : ''} ${className}`}
      />
      {error && <p className="text-xs text-danger mt-0.5">{error}</p>}
    </div>
  ),
);
Textarea.displayName = 'Textarea';
